import { parseFloatSafe } from "@omni/utils/number.utils";
import queryString from "query-string";
import { PureComponent } from "react";

import * as CalculatorStepTracker from "@/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@/services/tracking/trackers/tools/calculators/config";
import { asyncState, isValidPositiveNumber } from "@/utils/calculators";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

type YtongCalculatorState = {
    wallLength: string;
    wallHeight: string;
    wallArea: number;
    brickWidth: string;
    brickLength: string;
    brickHeight: string;
    brickArea: number;
};

class YtongCalculator extends PureComponent<{}, YtongCalculatorState> {
    query = queryString.parse(location.search);

    constructor(props: {}) {
        super(props);

        this.state = {
            wallLength: this.query.wallLength?.toString() || "0",
            wallHeight: this.query.wallHeight?.toString() || "0",
            brickWidth: this.query.brickWidth?.toString() || "0",
            brickLength: this.query.brickLength?.toString() || "0",
            brickHeight: this.query.brickHeight?.toString() || "0",
            wallArea: 0,
            brickArea: 0
        };
    }

    async componentDidMount() {
        await asyncState(this, {
            wallArea: this.wallArea(),
            brickArea: this.brickArea()
        });

        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.ytong);
    }

    // calculations
    wallArea = () => {
        return (
            parseFloatSafe(this.state.wallLength, 0) *
            parseFloatSafe(this.state.wallHeight, 0)
        );
    };
    brickArea = () => {
        let brickArea = 0;

        const brickLength = parseFloatSafe(this.state.brickLength, 0);

        const brickHeight = parseFloatSafe(this.state.brickHeight, 0);

        if (
            isValidPositiveNumber(brickLength) &&
            isValidPositiveNumber(brickHeight)
        ) {
            brickArea = (brickLength + 0.3) * (brickHeight + 0.3) * 0.0001;
        }

        return brickArea;
    };

    // setters
    setBrickMeasurements = (length: string, width: string, height: string) =>
        this.setState(
            {
                brickLength: length,
                brickWidth: width,
                brickHeight: height
            },
            () => this.calculateFields()
        );

    setCalculationValue = (field: string, value: string) => {
        this.setState(
            (state) => ({ ...state, [field]: value }),
            () => this.calculateFields()
        );
    };

    calculateFields = () =>
        this.setState(
            {
                wallArea: this.wallArea(),
                brickArea: this.brickArea()
            },
            () => {
                CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.ytong);
            }
        );

    render() {
        const calculationProps = {
            setCalculationValue: this.setCalculationValue,
            setBrickMeasurements: this.setBrickMeasurements,
            wallLength: this.state.wallLength,
            wallHeight: this.state.wallHeight,
            brickLength: this.state.brickLength,
            brickWidth: this.state.brickWidth,
            brickHeight: this.state.brickHeight
        };
        const resultProps = {
            wallArea: this.state.wallArea,
            brickArea: this.state.brickArea,
            brickWidth: parseFloatSafe(this.state.brickWidth, 0),
            mailParams: {
                wallLength: this.state.wallLength,
                wallHeight: this.state.wallHeight,
                brickLength: this.state.brickLength,
                brickWidth: this.state.brickWidth,
                brickHeight: this.state.brickHeight
            }
        };

        return (
            <div id="calculator">
                <Calculation {...calculationProps} />
                <Result {...resultProps} />
            </div>
        );
    }
}

export { YtongCalculator };
